import { render, staticRenderFns } from "./jianzhan.vue?vue&type=template&id=cbdb9008&scoped=true"
import script from "./jianzhan.vue?vue&type=script&lang=js"
export * from "./jianzhan.vue?vue&type=script&lang=js"
import style0 from "./jianzhan.vue?vue&type=style&index=0&id=cbdb9008&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb9008",
  null
  
)

export default component.exports